import FormRow from 'Components/FormRow';
import InputHandler from 'Components/InputHandler';
import { FormContext } from 'Containers/FormContextHandler';
import * as React from 'react';

const Doses = ({ formData, editIndex }: IDosesProps): React.JSX.Element => {
  const formContext = React.useContext(FormContext);
  const fm = formContext?.fm;

  const { document, onChange } = formData;

  const changeDoses = (values: TOnChangeValues): void => {
    const name = Object.keys(values)[0];
    if (!name) return;
    const value = values[name];
    const regimens = document.regimen ? [...document.regimen] : [];
    if (regimens[editIndex]) {
      regimens[editIndex] = { ...regimens[editIndex], doses: value } as IRegimenDefault;
      onChange?.({ regimen: regimens });
    }
  };

  const changeInterval = (values: TOnChangeValues): void => {
    const name = Object.keys(values)[0];
    if (!name) return;
    const value = values[name];
    const regimens = document.regimen ? [...document.regimen] : [];
    if (regimens[editIndex]) {
      regimens[editIndex] = { ...regimens[editIndex], interval: value } as IRegimenDefault;
      onChange?.({ regimen: regimens });
    }
  };

  const changeRepeatNumber = (values: TOnChangeValues): void => {
    const name = Object.keys(values)[0];
    if (!name) return;
    const value = values[name];
    const regimens = document.regimen ? [...document.regimen] : [];
    if (regimens[editIndex]) {
      regimens[editIndex] = { ...regimens[editIndex], repeatNumber: value } as IRegimenDefault;
      onChange?.({ regimen: regimens });
    }
  };

  return (
    <React.Fragment>
      <FormRow title="medication.doses.title" headerWidth={3}>
        <InputHandler
          type="NumberField"
          name="doses"
          formData={{
            document: { doses: (document.regimen?.[editIndex] as IRegimenDefault).doses },
            onChange: changeDoses,
          }}
          editing={true}
          placeholder="medication.doses.title"
          precision={2}
        />
      </FormRow>
      <FormRow title="medication.doses.repeatNumber" headerWidth={3}>
        <InputHandler
          type="NumberField"
          name="repeatNumber"
          editing={true}
          width={19}
          formData={{
            document: {
              repeatNumber: (document.regimen?.[editIndex] as IRegimenDefault).repeatNumber,
            },
            onChange: changeRepeatNumber,
          }}
          placeholder={'medication.doses.enterNumber'}
        />
      </FormRow>
      <FormRow title="medication.interval" headerWidth={3}>
        <InputHandler
          type="Select"
          name="interval"
          formData={{
            document: { interval: (document.regimen?.[editIndex] as IRegimenDefault).interval },
            onChange: changeInterval,
          }}
          options={['hourly', 'daily', 'weekly', 'monthly', 'yearly']}
          optionFormatter={(name: string | number): string => (fm ? fm(`medication.opts.${name}`) : '')}
          editing={true}
          placeholder="medication.chooseTimePeriod"
        />
      </FormRow>
    </React.Fragment>
  );
};

interface IDosesProps {
  editIndex: number;
  formData: IFormData<IDocumentWithTypeV2<'medication'>>;
}

export default Doses;
